import { ApiError } from '../../lib/api';

// Shared account helpers — were duplicated in AccountView + UserPane.

export function fmtAdded(at?: string): string {
  if (!at) return 'Seeded';
  const d = new Date(at);
  if (Number.isNaN(d.getTime())) return 'Seeded';
  return d.toLocaleDateString('en-IE', { day: 'numeric', month: 'short', year: 'numeric' });
}

// One error formatter for both call sites: prefer the server message, special-
// case the admins-only 403, fall back to the caller's message (or a generic one).
export function errMsg(err: unknown, fallback = 'Something went wrong.'): string {
  if (err instanceof ApiError) {
    if (err.message) return err.message;
    if (err.status === 403) return 'Admins only.';
    return `Something went wrong (${err.status}).`;
  }
  return fallback;
}
